module.exports = __webpack_public_path__ + "static/media/always_getting_smarter.2b33891d.svg";